/**
 * @consideration Maybe we should check if the token exist before passing it
 * and remove the undefined type in the future
 */ export var isTokenProvisional = function(token) {
    if (!token) return false;
    var tokenData = JSON.parse(atob(token.split(".")[1]));
    return !!tokenData.isProvisional;
};
